import { motion } from "framer-motion";

const EASE = [0.33, 1, 0.68, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ index, overline, title, align = "left", testid }) => (
  <Reveal className={align === "center" ? "text-center" : ""}>
    <p
      className="text-xs uppercase tracking-[0.35em] text-gold/80"
      data-testid={`section-${testid}-overline`}
    >
      {index} — {overline}
    </p>
    <h2 className="mt-4 font-serif text-3xl uppercase tracking-wide text-[#FAFAFA] md:text-4xl lg:text-5xl">
      {title}
    </h2>
    <div className={`mt-6 h-px w-24 bg-gradient-to-r from-gold to-transparent ${align === "center" ? "mx-auto bg-gradient-to-r from-transparent via-gold to-transparent" : ""}`} />
  </Reveal>
);
